import styles from '../../../MultiStepPMSLogin.module.scss'
import property1 from './property1.png'
import property2 from './property2.png'
import property3 from './property3.png'
import property4 from './property4.png'
import property5 from './property5.png'

const PropertyAccess = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        Please access to given page below and switch to access request section. Search for
        "gxp" from the input.
      </p>
      <p className={styles.descriptionTextEmp}>
        Select "Regional/Above Property" choice.
      </p>
      <img src={property1} width={'500px'} alt="" />
      <p className={styles.descriptionTextEmp}>Click on "Request New Account" button.</p>
      <img src={property2} width={'500px'} alt="" />
      <p className={styles.descriptionTextEmp}>Fill in the related fields shown below.</p>
      <img src={property3} width={'500px'} alt="" />
      <p className={styles.descriptionTextEmp}>Click on the "Review & Submit" button.</p>
      <img src={property4} width={'500px'} alt="" />
      <p className={styles.descriptionTextEmp}>After review, submit the form.</p>
      <img src={property5} width={'500px'} alt="" />
    </div>
  )
}

export default PropertyAccess
